// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__9lS2T","effect":"Loader_effect__mdL41"};